<div class="form-header">
  <div class="form-header__content">
    <h2 class="title">{{ title() }}</h2>
    <h3 class="subtitle">{{ 'TGA.Questionnaire.Generic.General.FormSection.Subtitle' | translate }}</h3>
    <div>
      <p class="description-underline">
        {{ 'TGA.Questionnaire.Generic.General.FormSection.DescriptionUnderline' | translate }}
      </p>
      <p class="description-underline">
        {{ 'TGA.Questionnaire.Generic.General.FormSection.Description' | translate }}
      </p>
    </div>
  </div>
</div>
